import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { isEmpty, Namespace, StatusTypes, Component, SharedCommandNames, fireStatusUpdate } from '@chegg/commerce-utils';
import { sendNewRelicError } from '../../utils/NewRelicUtils';
import { ERRORS } from '../../constants/Errors';
import { executeCommands } from './CommandState.actions';
import { resetFieldsCommand, verifyAddressCommand, reauthorizeCommand, saveConfigsCommand } from './CommandState.helpers';
import { Commands } from './CommandState.types';
var COMMAND_HANDLERS = _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, Commands.CommandNames.RESET_FIELDS, resetFieldsCommand), Commands.CommandNames.VERIFY_ADDRESS, verifyAddressCommand), Commands.CommandNames.REAUTHORIZE, reauthorizeCommand), Commands.CommandNames.SAVE_CONFIGS, saveConfigsCommand);
export var executeCommandsListener = {
  actionCreator: executeCommands,
  effect: function effect(_ref, listenerApi) {
    var commands = _ref.payload;
    if (!commands || isEmpty(commands)) {
      return;
    }
    commands.forEach(function (command) {
      switch (command.commandName) {
        case Commands.CommandNames.RESET_FIELDS:
        case Commands.CommandNames.VERIFY_ADDRESS:
        case Commands.CommandNames.REAUTHORIZE:
        case Commands.CommandNames.SAVE_CONFIGS:
          COMMAND_HANDLERS[command.commandName](listenerApi.getState(), listenerApi.dispatch, command);
          break;
        default:
          sendNewRelicError("Unsupported Command: ".concat(command.commandName));
          fireStatusUpdate([{
            status: StatusTypes.ERROR,
            command: SharedCommandNames.UNKNOWN_CALLBACK,
            payload: {
              component: Component.EXECUTE_COMMAND_LOGIC,
              errors: [_objectSpread(_objectSpread({}, ERRORS.UNSUPPORTED_COMMAND), {}, {
                message: "Unsupported Command: ".concat(command.commandName)
              })]
            }
          }], Namespace.USER_ADDRESS);
      }
    });
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/user-address/dist/esm/redux/CommandState/CommandState.listeners.js
// module id = 4424
// module chunks = 11